<template>
  <div class="copy-to-clipboard-text">
    <div class="d-flex align-items-center justify-content-start">
      <textarea
          ref="copyVal"
          :value="value"
          class="copy-item d-inline-block"
          readonly
          rows="1"
      ></textarea>
      <div class="clickable lighter d-inline-block copy-icon" @click="copyValToClipboard">
        <icon type="copy"/>
      </div>
    </div>
    <div ref="ghost" class="ghost">{{ value }}</div>
  </div>
</template>

<script>
import Icon from "@/components/Icon.vue";
export default {
  name: "CopyToClipboardText" ,
  components: {Icon},
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      copied: false
    };
  },
  watch: {
    value() {
      this.adaptSizeToTextContent();
    }
  },
  mounted() {
    this.adaptSizeToTextContent();
  },
  methods: {
    adaptSizeToTextContent() {
      this.$nextTick(() => {
        const copyText = this.$refs.copyVal;
        const ghost = this.$refs.ghost;

        if (copyText && ghost) {
          // sync ghost text *before* measuring!
          ghost.textContent = copyText.value || ' ';
          const widthOfGhost = ghost.offsetWidth;
          copyText.style.width = `${widthOfGhost + 5}px`;

          const heightOfGhost = ghost.offsetHeight;
          copyText.style.height = `${heightOfGhost + 5}px`;

        }
      });
    },
    copyValToClipboard() {
      const copyText = this.$refs.copyVal;
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices
      document.execCommand("copy");
      copyText.blur(); // Remove focus and selection

      this.copied = true;
      this.$store.dispatch('createNotification', {'text': this.$t('valueCopiedToClipboard')});
      setTimeout(() => {
        this.copied = false;
      }, 2000);
    }
  },
}
</script>

<style lang="scss">
.copy-icon {
  margin-top: -2px;
}
.copy-item {
  background-color: transparent;
  color: #fff;
  border-color: transparent;
  padding-left:0;
  user-select: none;
  pointer-events: none;
  word-wrap: break-word;       /* Old school */
  overflow-wrap: break-word;   /* New school */
  resize: none;
  overflow: hidden;
  flex: 1;
  max-width: 90%;
  &:focus, &:focus-visible {
    outline: none;
  }
}
.copy-to-clipboard-text {
  position: relative;
  &.dark {
    .copy-item {
      color: #000;
    }
  }
}
.ghost {
  position: absolute;
  top: 0;
  left: 0;
  visibility: hidden;
  //background: red;
  font: inherit;
  //overflow-wrap: anywhere;
  overflow-wrap: break-word; /* modern & nice */
  word-break: break-word;
  display: block;
  width: 100%;
}
</style>